/** Send only the edited language so the API can auto-translate the others. */
export const buildLocalizedFieldForApi = (lang, value) => ({
  [lang]: value ?? "",
});
